import breakpoints from '@/breakpoints';
import useMobileView from '@/hooks/useMobileView';

/**
 * Whether the calendar carries an employee picker of its own, which is what decides the
 * employee step's existence: where the calendar can be asked for an employee, the step is
 * redundant and the pick is made there instead.
 *
 * `lg`, not `useMobileView`'s `md`: `lg` is where the calendar's side column — and with it
 * `SelectedEmployeePanel` — appears, so every width has exactly one employee affordance.
 *
 * Deliberately live, not frozen per flow entry: a tablet rotating across `lg` while parked on
 * a step page gets redirected onward and loses unsaved drawer edits, but a frozen "narrow"
 * decision would leave the step reachable behind a calendar that already shows the panel —
 * two affordances, the very thing this rule exists to rule out.
 */
export function useCalendarOffersEmployeePick(): boolean {
  const { windowSize } = useMobileView();
  return windowSize.width >= breakpoints.lg;
}
